/**
 * @fileoverview GET handler for the "/app_settings/:app_group_id/api_keys/:api_key_id/metadata" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsAppGroupIdApiKeysApiKeyIdMetadata } from "./constants";
import type { GetAppSettingsAppGroupIdApiKeysApiKeyIdMetadataResult } from "./types";
import { isGetAppSettingsAppGroupIdApiKeysApiKeyIdMetadataResult } from "./validators";

export const getAppSettingsAppGroupIdApiKeysApiKeyIdMetadata = reactQueryFetcherAdapter(
  appSettingsAppGroupIdApiKeysApiKeyIdMetadata,
  (
    signal: AbortSignal,
    appGroupId: string,
    apiKeyId: string
  ): Promise<GetAppSettingsAppGroupIdApiKeysApiKeyIdMetadataResult> => {
    return fetch(`/app_settings/${appGroupId}/api_keys/${apiKeyId}/metadata`, "GET", {}, { signal });
  },
  isGetAppSettingsAppGroupIdApiKeysApiKeyIdMetadataResult
);
